
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/event/forum",
      function () {
        return require("private-next-pages/en/event/forum/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/event/forum"])
      });
    }
  